export const userListTranslations = {
    en: {
        // Page Title
        userList: "User List",
        allUsers: "All",

        // Table Headers
        action: "Action",
        name: "Name",
        email: "Email",
        mobile: "Mobile",
        userType: "User Type",
        isActive: "Is Active",
        pinCode: "Pin Code",
        taluka: "Taluka",
        district: "District",

        // Buttons
        createNewUser: "Create New User",

        // Form Labels
        selectUserType: "Select User Type",
        searchUsers: "Search Users",

        // Tooltips
        clearSearch: "Clear Search",
        search: "Search",

        // Status
        searching: "Searching...",

        // Dialog Titles
        updateDetails: "Update Details",
        registerNewUser: "Register New User",

        // Common
        noData: "--",

        // Module Name
        userListModule: "User List",
    },
    mr: {
        // Page Title
        userList: "वापरकर्ता यादी",
        allUsers: "सर्व",

        // Table Headers
        action: "क्रिया",
        name: "नाव",
        email: "ईमेल",
        mobile: "मोबाइल",
        userType: "वापरकर्ता प्रकार",
        isActive: "सक्रिय आहे",
        pinCode: "पिन कोड",
        taluka: "तालुका",
        district: "जिल्हा",

        // Buttons
        createNewUser: "नवीन वापरकर्ता तयार करा",

        // Form Labels
        selectUserType: "वापरकर्ता प्रकार निवडा",
        searchUsers: "वापरकर्ते शोधा",

        // Tooltips
        clearSearch: "शोध साफ करा",
        search: "शोधा",

        // Status
        searching: "शोधत आहे...",

        // Dialog Titles
        updateDetails: "तपशील अद्यतनित करा",
        registerNewUser: "नवीन वापरकर्ता नोंदणी करा",

        // Common
        noData: "--",

        // Module Name
        userListModule: "वापरकर्ता यादी",
    }
};
